/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./modal-body.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { TouchScrollable } from 'react-scrolllock';
import { fg } from '@atlaskit/platform-feature-flags';
import { useModal } from './hooks';
import ScrollContainer from './internal/components/scroll-container';
import useScroll from './internal/hooks/use-scroll';
var bodyStyles = null;
var fontStyles = null;

/**
 * Adding the padding here avoids cropping the keyline on its sides.
 * The combined vertical spacing is maintained by subtracting the
 * keyline height from header and footer using negative margins.
 */
var bodyScrollStyles = null;

/**
 * Keylines will not be shown if scrolling in viewport so we do
 * not account for them in this case.
 */
var viewportScrollStyles = null;
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */
var ModalBody = function ModalBody(props) {
  var children = props.children,
    userDefinedTestId = props.testId;
  var _useModal = useModal(),
    modalTestId = _useModal.testId;
  var shouldScrollInViewport = useScroll();
  var testId = userDefinedTestId || modalTestId && "".concat(modalTestId, "--body");
  return shouldScrollInViewport ? /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: ax(["_16jlkb7n _1o9zkb7n _i0dl1wug", "_18zr1ejb", fg('platform_ads_explicit_font_styles') && "_11c82smr"])
  }, children) : /*#__PURE__*/React.createElement(TouchScrollable, null, /*#__PURE__*/React.createElement(ScrollContainer, {
    testId: userDefinedTestId || modalTestId
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: ax(["_16jlkb7n _1o9zkb7n _i0dl1wug", "_1rjc1bk5 _18zr1ejb", fg('platform_ads_explicit_font_styles') && "_11c82smr"])
  }, children)));
};
export default ModalBody;